// 药店建档变更日志详情
<template>
  <div class="explain" v-loading.fullscreen.lock="fullscreenLoading">
    <LogDetailView :LogDetail="LogDetail" :objectType="objectType"></LogDetailView>
  </div>
</template>
<script>
import LogDetailView from './components/LogDetailView';
export default {
  components: {
    LogDetailView,
  },
  data() {
    return {
      LogDetail: {},
      fullscreenLoading: false,
      objectType:'1'
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      let self = this;
      this.fullscreenLoading = true;
      let query = {
        tenantGuid: localStorage.guid,
        guid: self.$route.query.bizGuid,
      };
      self.api
        .get(
          `/${serverConfig.msCustomerService}/customer-history/detail/property-guid?propertyApprovalGuid=${self.$route.query.guid}&objectType=${this.objectType}`,
        )
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.LogDetail = res.data.data ? res.data.data : {};
            if (!res.data.data) {
              self.$message.error('未获取到数据');
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
  },
};
</script>
<style scoped>
/* 标题 */
.page-title-box {
  height: 44px;
  line-height: 44px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  box-sizing: border-box;
  background: #ffffff;
  border-bottom: 1px solid #d9d9d9;
}
.page-back {
  width: 60px;
  height: 28px;
  line-height: 28px;
  border-radius: 2px;
  cursor: pointer;
  border: 1px solid #d9d9d9;
}
.page-title {
  flex: 1;
  font-size: 16px;
  text-align: center;
}
/* 内容 */
.explain-contain {
  background: #fff;
  padding: 20px 20px 30px 60px;
}
.explain-item {
  line-height: 40px;
  display: flex;
}
.explain-title {
  flex-shrink: 0;
}
.explain-content {
  display: inline-block;
  /* line-height: 30px; */
}
</style>
